import { api } from "@/shared/api/client";
import {
    ProjectDiaryGetDTO,
    ProjectDiariesGetDTO,
    ProjectDiaryCreateDTO,
    ProjectDiaryUpdateDTO,
    PageProjectDiariesGetDTO,
    ProjectDiaryRequestDTO,
    ProjectDiaryMediaDTO,
} from "@/shared/types/project/projectDiary";

export const projectDiaryService = {
    getAll: async (
        projectId: string,
        params: ProjectDiaryRequestDTO
    ): Promise<PageProjectDiariesGetDTO> => {
        const response = await api.get<PageProjectDiariesGetDTO>(
            `/projects/${projectId}/project-diaries`,
            {
                params: {
                    ...params.filter,
                    page: params.page - 1,
                    size: params.size,
                    sort: params.sort,
                },
            }
        );
        return response.data;
    },

    getById: async (
        projectId: string,
        diaryId: string
    ): Promise<ProjectDiaryGetDTO> => {
        const response = await api.get<ProjectDiaryGetDTO>(
            `/projects/${projectId}/project-diaries/${diaryId}`
        );
        return response.data;
    },

    create: async (
        projectId: string,
        data: ProjectDiaryCreateDTO
    ): Promise<ProjectDiaryGetDTO> => {
        const response = await api.post<ProjectDiaryGetDTO>(
            `/projects/${projectId}/project-diaries`,
            data
        );
        return response.data;
    },

    update: async (
        projectId: string,
        diaryId: string,
        date: string,
        data: ProjectDiaryUpdateDTO
    ): Promise<ProjectDiaryGetDTO> => {
        const response = await api.put<ProjectDiaryGetDTO>(
            `/projects/${projectId}/project-diaries/${diaryId}`,
            data
        );
        return response.data;
    },

    uploadMedia: async (
        projectId: string,
        diaryId: string,
        date: string,
        files: File[]
    ): Promise<ProjectDiaryMediaDTO[]> => {
        const formData = new FormData();
        files.forEach(file => {
            formData.append('files', file);
        });

        const response = await api.post<ProjectDiaryMediaDTO[]>(
            `/projects/${projectId}/project-diaries/${diaryId}/media`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
        );
        return response.data;
    },

    getAllMedia: async (
        projectId: string,
        diaryId: string,
        date: string
    ): Promise<ProjectDiaryMediaDTO[]> => {
        const response = await api.get<ProjectDiaryMediaDTO[]>(
            `/projects/${projectId}/project-diaries/${diaryId}/media`
        );
        return response.data;
    },

    getMediaById: async (
        projectId: string,
        diaryId: string,
        date: string,
        mediaId: string
    ): Promise<Blob> => {
        const response = await api.get(
            `/projects/${projectId}/project-diaries/${diaryId}/media/${mediaId}`,
            { responseType: 'blob' }
        );
        return response.data;
    },

    deleteMedia: async (
        projectId: string,
        diaryId: string,
        date: string,
        mediaId: string
    ): Promise<void> => {
        await api.delete(
            `/projects/${projectId}/project-diaries/${diaryId}/media/${mediaId}`
        );
    },

    getAllByDateGlobal: async (
        date: string,
        params: ProjectDiaryRequestDTO
    ): Promise<PageProjectDiariesGetDTO> => {
        const response = await api.get<PageProjectDiariesGetDTO>(
            `/projects/diaries-by-date`,
            {
                params: {
                    date,
                    page: params.page - 1,
                    size: params.size,
                    sort: params.sort,
                },
            }
        );
        return response.data;
    },

    syncPoints: async (
        projectId: string,
        diaryId: string
    ): Promise<void> => {
        await api.post(
            `/projects/${projectId}/project-diaries/${diaryId}/register-points`
        );
    },
};
